/** - Este Script se encarga de almacenar las variables globales que pueden y 
 * seran accedidas por todos los demas scripts que se carguen despues de este
 * @author Maki Parodi - IGM (Sección: SIG)
 */
let w = /** @type {ExtendedWindow} */ (window);

//obtengo la version del visualizador
const version = require('./package.json').version;
const LastUpdate = require('./package.json').LastUpdateDate;

w.Version = "v" + version;
w.LastUpdateDate = LastUpdate;

document.title = "SIGAUY " + w.Version;

w.isMobile = false; //initiate as false

//#region CREDITOS QUE NO SE VEN
w.ProgramadorPrincipal = "Programador Principal:\nCabo 2da Agustín Parodi"
w.SegundoProgramador = "2° Programador:\nCabo 2da Gillermo Trifunovic"
w.ApoyoSIG = "Apoyo SIG (WMSs):\nCabo 1ra Federico Sclavi"

let Creditos =  "*Maki Parodi \n" +
                "  >Gestion y control de NodeJS\n"+
                "  >Frontend y Backend en JS, \n" +
                "  >Diseño de interface e iconos SVG\n" +
                "  >implementación de Geoserver\n"+
                "  >implementación de Herramientas interactivas\n"+
                "  >procesamiento COG usando GDAL\n"+
                "\n" +
                "*Guillermo Trifunovic \n" +
                "  >investigacion del Backend original\n" +
                "  >Integracion de Herramientas de Edición en etapas tempranas\n" +
                "\n" +
                "*Federico Sclavi \n" +
                "  >Simbolizacion WMS con Qgis\n" +
                "  >Carga de Capas en Geoserver\n"+
                "\n" +
                "*Creado utilizando las siguientes Tecnologias\n" +
                "  >NodeJS 14 LTS\n" +
                "  >Parcel\n" +
                "  >JQuery\n" +
                "  >Open Layers 6\n"+
                "  >GitHub como Gestor de Repoitorios";

w.Creditos = Creditos;
w.creditos = Creditos;
w.Creadores = Creditos;
w.creadores = Creditos;
w.Contributors = Creditos;
w.contributors = Creditos;
w.Creators = Creditos;
w.creators = Creditos;
//#endregion

//#region CREDITOS QUE SE VEN EN EL VISUALIZADOR
w.Credits =   "SIGAUY: " + w.Version +
            "\nUltima Actualización: " + w.LastUpdateDate +
            "\n" +
            "\nDesarrollado por el \nInstituto Geográfico Militar" +
            "\n" +
            "\nTecnologias Utilizadas:" +
            "\nNodeJS v12.18.4  |  NPM v6.14.6" +
            "\nparcel-bundler v1.12.5  |  JQuery v3.6.0"+
            "\nOpenLayers v6.5.0  |  proj4 v2.7.2"+
            "\nhtml2canvas v1.0.0 rc 7"
            "\n" +
            "\nCapas Servidas utilizando:" +
            "\nGeo Server v2.19.0 Stable" +
            "\nPortal For Arcgis";

w.CreditsHTML =`<div>
                    <div class="tabla_creditos_titulo" > CREDITOS </div>
                    <br>
                    <span> <b>SIGAUY: </b> ${w.Version}<span> <br>
                    <span> <b>Ultima Actualización:</b> ${w.LastUpdateDate}<span> <br>
                    <br>
                    <span>Desarrollado por el </span> <br>
                    <span>Instituto Geográfico Militar</span> <br>
                    <br>
                    <div class="tabla_creditos_titulo" >Tecnologias Utilizadas:</div>
                    <table class="tabla_creditos">

                        <tr> 
                            <td colspan=2> <a class="link" href="https://nodejs.org/es/" target="_blank">NodeJS</a> </td> 
                        </tr>

                        <tr> 
                            <td> <a class="link" href="https://www.npmjs.com/" target="_blank">NPM</a> </td> 
                            <td> <a class="link" href="https://parceljs.org/" target="_blank">parcel-bundler</a> </td>
                        </tr>

                        <tr> 
                            <td> <a class="link" href="https://jquery.com/" target="_blank">JQuery</a> </td> 
                            <td> <a class="link" href="https://openlayers.org/" target="_blank">OpenLayers</a> </td> 
                        </tr>

                        <tr> 
                            <td> <a class="link" href="https://www.npmjs.com/package/proj4" target="_blank">proj4</a> </td>
                            <td> <a class="link" href="https://html2canvas.hertzen.com/" target="_blank">html2canvas</a> </td>
                        </tr>
                        
                    </table>
                    <br>
                    <div  class="tabla_creditos_titulo" >Capas Servidas utilizando:</div>
                    <table class="tabla_creditos">
                        <tr> 
                            <td> <a class="link" href="http://geoserver.org/" target="_blank">Geo Server</a> </td> 
                            <td> <a class="link"href="http://igm.gub.uy" target="_blank">Arcgis Portal del IGM </a></td> 
                        </tr>
                    </table>
                </div>`

//console.log(w.CreditsHTML)
//#endregion

//#region Ventanas, Variables Globales

    //ventanas flotantes
    w.VentanaCrearCapa = null;
    w.VentanaEliminarCapa = null;
    w.VentanaDescargarCapa = null;
    w.VentanaSubirCapa = null;
    w.VentanaPrintPNG = null;
    w.VentanaEditar = null
    w.VentanaOpciones = null;
    w.VentanaCargarWMS = null;
    w.VentanaComprobarInformacion = null;
    w.VentanaComprobarInformacionFisrtTime = false
    w.VentanaCapasDelIGM = null;
    w.VentanaExportandoMapa = null;
    w.VentanaTips = null;
    w.VentanaAyuda = null;

    //declaro la operacion como null. de manera global, para usarla en caso de que se hagan operaciones
    w.operationWindow = null;
//#endregion

w.standarToolTipDelayInMS = 400;
w.ToolTipElem =  document.getElementsByClassName("ToolTip")[0];